module.exports = __webpack_public_path__ + "img/icon-warning-yellow.aaee1df9.svg";